import application from "stimulus_application";
import { definitionsFromContext } from "stimulus/webpack-helpers";
import "./contact_form_group_travel.css";

const context = require.context("./", true, /_controller\.js$/);
application.load(definitionsFromContext(context));
